import { FallbackImage } from '@/components/commons/fallback-image';
import ModalSelectProduct from '@/components/sections/builder/settings/modal-select-product';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import useModal from '@/hooks/useModal';
import { IProduct } from '@/types/product';
import { ExternalLinkIcon, RefreshCcwIcon, Trash2Icon } from 'lucide-react';
import { ChevronDown } from 'lucide-react';

type ProductSettingType = {
  value?: Partial<IProduct>;
  onChange?: (value?: Partial<IProduct>) => void;
};

export default function ProductSetting({ value, onChange }: ProductSettingType) {
  const selectProductModal = useModal<Partial<IProduct>>();

  if (!value) {
    return (
      <>
        <div className='mb-4 font-bold'>Product</div>
        <Button
          type='button'
          variant='outline'
          className='flex w-full gap-x-2 bg-white'
          onClick={() => {
            selectProductModal.open(value);
          }}
        >
          <span>Select Product</span>
        </Button>
        <ModalSelectProduct
          initialValues={value}
          openModal={selectProductModal.isShow}
          setOpenModal={(e) => !e && selectProductModal.setIsShow(e)}
          onSelect={(product) => {
            onChange?.(product);
          }}
        />
      </>
    );
  }

  return (
    <>
      <div className='mb-4 font-bold'>Product</div>
      <div className='rounded-md bg-gray-50 py-4'>
        <div className='mb-4 flex gap-x-2 border-b border-white px-4 pb-3'>
          <FallbackImage
            src={
              value.product_assets && value.product_assets.length > 0
                ? value.product_assets?.[0]?.assets_url
                : 'https://placehold.co/400'
            }
            alt={value.product_name as string}
            width={41}
            height={41}
            className='mr-2 h-[41px] w-[41px] rounded border object-contain'
          />
          <div className='w-[150px]'>{value.product_name}</div>
          <ExternalLinkIcon className='h-4 w-4' />
        </div>
        <div className='px-4'>
          <DropdownMenu modal={false}>
            <DropdownMenuTrigger asChild>
              <Button type='button' variant='outline' className='flex w-full gap-x-2 bg-white'>
                <span>Change</span>
                <ChevronDown className='h-4 w-4' />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className='w-full'>
              <DropdownMenuItem
                onClick={() => {
                  selectProductModal.open(value);
                }}
              >
                <RefreshCcwIcon className='mr-2 h-4 w-4' />
                <div>Change product</div>
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => onChange?.()}>
                <Trash2Icon className='mr-2 h-4 w-4' />
                <div>Remove product</div>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
      <ModalSelectProduct
        initialValues={value}
        openModal={selectProductModal.isShow}
        setOpenModal={(e) => !e && selectProductModal.setIsShow(e)}
        onSelect={(product) => {
          onChange?.(product);
        }}
      />
    </>
  );
}
